<template>
	<div class="page-villain">
		<router-link @click="toTop" to="/">
			<div class="keys"></div>
		</router-link>
		<a href="#" class="logo">
			<img src="/themes/rise-theme/dist/images/estate/character-view/villian/Villain_Title@2x.png" alt="">
		</a>

		<img class="img-fixed" src="/themes/rise-theme/dist/images/estate/character-view/villian/Villain_PostIt.png" alt="">
		<img class="img-center animated"
			src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain@2x.png" alt="">

		<div class="text animated">
			<div class="inner-scroll">
				<div class="animated" v-html="lang('villain_text')"></div>
			</div>

		</div>

		<!-- THREE SCREEN -->
		<div class="section third" ref="third">
			<div class="group-image show board">


				<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/CasesBoard_Background@2x.png"
					alt="" class="bg">

				<div class="vanessa profile animated">
					<router-link to="/character/vanessa">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png)">
					</div>
				</div>
				<div class="holy profile animated">
					<router-link to="/character/holly">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png)">
					</div>
				</div>
				<div class="henry profile animated">
					<router-link to="/character/henry">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png)">
					</div>
				</div>
				<div class="ozzie profile animated">
					<router-link to="/character/ozzie">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png)">
					</div>
				</div>
				<div class="villain profile animated">
					<router-link to="/character/villian">
						<img class="character-icon"
							data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png"
							src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain@2x.png" alt="">
					</router-link>
					<div class="shadow-img invisible"
						style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png)">
					</div>
				</div>
			</div>
			<div class="intro_hand1"></div>
			<div class="intro_hand2"></div>
		</div>
		<langControl/>
		<!-- // THREE SCREEN -->
	</div>
</template>

<script>
import helpers from '../../util/helpers';
import langControl from '../../components/langControl.vue'
export default {
	components: {
		langControl
	},
	inject: ['lang'],
	methods: {
		animated() {
			const animated = document.querySelectorAll('.animated');

			setTimeout(() => {
				animated.forEach(animated => animated.classList.add('show'));
			}, 500);
		},
		toTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
	},
	mounted() {
		this.animated();
		window.document.querySelector('html').scrollTo({
			top: 0,
			behavior: "smooth"
		});
		setTimeout(() => {
			helpers.enableScrolling();
		}, 1000);

	}
}
</script>

<style lang="scss" scoped>
img {
	max-width: 100%;
	height: auto;
}

.page-villain {
	background: #000 url('/themes/rise-theme/dist/images/estate/character-view/villian/01_IntroBackground.png') no-repeat fixed center;
	background-size: cover;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 1;

	@media (max-width: 1080px) {
		height: auto;
	}

	// overflow: hidden;

	.logo {
		display: inline-block;
		transform: translateX(-50%);
		margin-left: -30px;
		position: absolute;
		top: 0;
		left: 50%;
		max-width: 300px;

		@media(min-width: 600px) and (max-width: 1280px) {
			zoom: 0.65;
		}
	}

	.img-fixed {
		width: 200px;
		display: block;
		position: fixed;
		top: -55px;
		right: -50px;

		@media(min-width: 600px) and (max-width: 1280px) {
			zoom: 0.65;
		}
	}

	.img-center {
		max-width: 600px;
		margin-left: -75px;
		transition: all 0.5s;
		margin-top: auto;

		@media(min-width: 600px) and (max-width: 1280px) {
			zoom: 0.65;
		}

		&.show {
			transform: scale(0.8);
		}
	}

	.keys {
		position: fixed;
		right: 35px;
		top: 0;
		background-image: url(/themes/rise-theme/dist/images/estate/about/About_Background_Keys.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		width: 210px;
		height: 260px;
		z-index: 1;
		cursor: pointer;

		@media(min-width: 600px) and (max-width: 1280px) {
			zoom: 0.65;
		}

		@media(max-width: 600px) {
			display: none;
		}
	}

	.text {
		margin-bottom: auto;
		background: rgba(0, 0, 0, .7);
		border-radius: 15px;
		padding: 30px;
		max-width: 800px;
		transition: all 1s;
		transform: scale(1) translateY(100%);
		position: relative;
		z-index: 3;
		color: #fff;
		font-family: 'American-typewriter', serif;

		@media(min-width: 600px) and (max-width: 1280px) {
			zoom: 0.65;
		}

		&.show {
			transform: scale(1) translateY(-50px);
		}

		.inner-scroll {
			//   max-height: 150px;
			overflow-y: auto;
		}

		.inner-scroll::-webkit-scrollbar {
			width: 3px;
		}

		.inner-scroll::-webkit-scrollbar-track {
			background: #000;
		}

		.inner-scroll::-webkit-scrollbar-thumb {
			background: #343434;
		}

		p+p {
			margin-top: 25px;
		}

		p {
			opacity: 0;

			&:first-child {
				transition: all 0.3s 0.5s;
			}

			&:last-child {
				transition: all 0.3s 1s;
			}
		}

		p.show {
			opacity: 1;
		}
	}
}

.section.third {
	position: relative;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
	height: 100vh;

	@media(max-width: 600px) {
		min-height: 100vh;
		align-items: center;
	}

	.intro_hand1 {
		width: 290px;
		height: 900px;
		position: absolute;
		background-image: url('/themes/rise-theme/dist/images/estate/Intro_Hand_01.png');
		background-size: contain;
		background-repeat: no-repeat;
		top: calc(50% + 185px);
		left: 50%;
		transform: translateX(-50%);
		margin-left: -570px;

		@media (max-width: 1500px) {
			top: calc(50% + 120px);
			margin-left: -450px;
		}

		@media (max-width: 1200px) {
			top: calc(50% + 50px);
			margin-left: -340px;
		}

		@media (max-width: 991px) {
			top: calc(50% + 20px);
			margin-left: -270px;
		}

		@media(max-width:600px) {
			top: calc(50% + 105px);
			left: calc(50% - 257px);
			width: 200px;
		}
	}

	.intro_hand2 {
		width: 400px;
		height: 900px;
		position: absolute;
		background-image: url('/themes/rise-theme/dist/images/estate/Intro_Hand_02.png');
		background-size: contain;
		background-repeat: no-repeat;
		top: calc(50% + 267px);
		left: 50%;
		transform: translateX(-50%);
		margin-left: 550px;

		@media (max-width: 1500px) {
			top: calc(50% + 200px);
			margin-left: 460px;
		}

		@media (max-width: 1200px) {
			top: calc(50% + 131px);
			margin-left: 360px;
		}

		@media (max-width: 991px) {
			top: calc(50% + 85px);
			margin-left: 290px;
		}

		@media(max-width:600px) {
			top: calc(50% + 146px);
			left: calc(50% + 36px);
			width: 300px;
		}
	}

	.group-image {
		transition: opacity 0.3s 1s linear;
		position: relative;
		bottom: 0;
		left: 50%;
		margin-right: 0;
		max-width: 1500px;
		transform: translateX(-50%);
		margin-left: -185px;

		&>img {
			max-width: 100%;
		}

		.profile {
			position: absolute;
			left: 50%;
			top: 50%;
			z-index: 1;
			width: 200px;
			transform: translate(-50%, -50%) scale(1);
			transition: transform 0.3s 0.5s;

			&.disabled {
				pointer-events: none;

				img {
					filter: brightness(0.35);
				}
			}

			img {
				width: 100%;

				&:hover {
					animation: swing ease-in-out 3s alternate;
					transform-origin: 97px 19px;
					animation-iteration-count: infinite;
					transition: transform 0.5s ease-in-out;
				}
			}

			&.vanessa {
				margin-left: -7.8%;
				margin-top: -5%;

				@media(max-width:600px) {
					margin-top: 12%;
				}

				img {
					&:hover {
						transform-origin: 80px 35px;
					}
				}
			}

			&.holy {
				margin-left: 6%;
				margin-top: -3.8%;

				@media(max-width:600px) {
					margin-left: 8%;
					margin-top: 12.2%;
				}

				img {
					&:hover {
						transform-origin: 98px 25px;
					}
				}
			}

			&.henry {
				margin-top: 11.7%;
				margin-left: -8.5%;

				@media(max-width:600px) {
					margin-top: -8.3%;
				}

				img {
					&:hover {
						transform-origin: 90px 31px;
					}
				}
			}

			&.ozzie {
				margin-left: 7.5%;
				margin-top: 12%;

				@media(max-width:600px) {
					margin-top: -7%;
				}

				img {
					&:hover {
						transform-origin: 96px 30px;
					}
				}
			}

			@media (max-width: 1200px) {
				width: 140px;
			}

			@media (max-width: 991px) {
				width: 115px;
			}

			@media(max-width: 600px) {
				left: 46%;
				top: 32%;
				transform-origin: center;
				transform: rotate(-90deg);
			}
		}

		.villain {
			position: absolute;
			left: calc(83% - 30px);
			top: calc(66% - 100px);
			z-index: 2;
			width: 300px;
			transition: opacity 0.3s 1s;

			img {
				height: 260px;
				width: auto;

				&:hover {
					animation: swing ease-in-out 3s alternate;
					transform-origin: 151px 28px;
					animation-iteration-count: infinite;
					transition: transform 0.5s ease-in-out;
				}

			}

			@media (max-width: 1500px) {
				left: calc(83% - 30px);
				top: calc(66% - 100px);
				width: 250px;

				img {
					height: 240px;
				}
			}

			@media (max-width: 1200px) {
				left: calc(83% - 30px);
				top: calc(74% - 100px);
				width: 200px;

				img {
					height: 200px;
				}
			}

			@media (max-width: 991px) {
				left: calc(86% - 50px);
				top: calc(70% - 60px);
				width: 150px;

				img {
					height: 160px;
				}
			}

			@media(max-width: 600px) {
				left: calc(77% - 45px);
				top: calc(50% - 60px);
				width: 150px;

				img {
					height: 150px;
				}
			}
		}

		&.show {
			opacity: 1;
		}

		@media (max-width: 1500px) {
			max-width: 1200px;
			margin-left: -148px;
		}

		@media (max-width: 1200px) {
			max-width: 900px;
			margin-left: -110px;
		}

		@media (max-width: 991px) {
			max-width: 700px;
			margin-left: -90px;
		}

		@media(max-width: 600px) {
			top: -13.3vh;
			transform: rotate(90deg) translateY(50%);
			transform-origin: center;
			min-width: 700px;
			margin-left: 0;
		}

		@media(max-width: 393px) {
			transform: rotate(90deg) translateY(47%);
		}

		@media(max-width: 390px) {
			transform: rotate(90deg) translateY(45%);
		}

		@media(max-width: 375px) {
			transform: rotate(90deg) translateY(47%);
		}

		@media(max-width: 360px) {
			transform: rotate(90deg) translateY(43%);
		}
	}
}

@media screen and (max-width: 1700px) {
	.page-villain .img-center {
		margin-left: -53px;
	}
}

@media screen and (max-width: 1600px) {
	.page-villain .img-fixed {
		width: 150px;
		top: -43px;
		right: -42px;
	}

	.page-villain .logo {
		font-size: 25px;
		padding: 10px;
	}

	.page-villain .img-center {
		max-width: 500px;
		margin-top: 80px;
	}
}

@media screen and (max-width: 750px) {
	.page-villain {
		justify-content: flex-start;
	}

	.page-villain .logo {
		margin-left: 0;
		font-size: 20px;
		padding: 10px 5px;
	}

	.page-villain .img-fixed {
		width: 100px;
		top: -29px;
		right: -32px;
	}

	.page-villain .img-center {
		margin-left: 0;
	}
}</style>
